import { Injectable } from '@angular/core';
import { User } from 'src/app/core/model/user-model';
declare var webengage;

@Injectable({
  providedIn: 'root',
})
export class WebengageService {
  constructor() {}
  appLaunch() {
    webengage.track('app_opened');
  }
  userLoggedin(user: User) {
    (window as any).webengage.user.login(user._id);
    if (user.email) {
      (window as any).webengage.user.setAttribute('we_email', user.email);
    }
    if (user.username) {
      (window as any).webengage.user.setAttribute(
        'we_phone',
        '+98' + user.username.substring(1)
      );
    }
    if (user.name) {
      (window as any).webengage.user.setAttribute('we_first_name', user.name);
    }
    if (user.sex) {
      (window as any).webengage.user.setAttribute('we_gender', user.sex);
    }
    if (user.birthDate) {
      (window as any).webengage.user.setAttribute(
        'we_birth_date',
        new Date(user.birthDate).toISOString().slice(0, 10)
      );
    }
    if (user.weight) {
      (window as any).webengage.user.setAttribute('weight', user.weight);
    }
    if (user.height) {
      (window as any).webengage.user.setAttribute('height', user.height);
    }
    (window as any).webengage.user.setAttribute('market', 'pwa');
  }
  authenticated(type: string) {
    webengage.track('authenticated', {
      authentication_type: type,
    });
  }
  userCodeLogin() {
    let user: User = JSON.parse(localStorage.getItem('user'));
    if (user && user._id) {
      this.userLoggedin(user);
    }
  }
  shopVisited() {
    webengage.track('shop_visited');
  }
  dieGenerated(dietName: string, dietGoal: string) {
    webengage.track('diet_generated', {
      diet_name: dietName,
      diet_type: dietGoal,
    });
  }
  foodPackageStatusChanged() {
    webengage.track('food_package_added');
  }
  addFoodLog(meal: string, type: string) {
    webengage.track('food_log_added', {
      meal,
      type,
    });
  }
  exerciseLogAdded(type: string) {
    webengage.track('exercise_log_added', {
      type,
    });
  }
  waterLogAdded(amount: number) {
    webengage.track('water_log_added', {
      amount,
    });
  }
  weightLogAdded(weight: number) {
    webengage.track('weight_log_added', {
      weight,
    });
  }
  shopping_item_added() {
    webengage.track('shopping_item_added');
  }
  kitchen_item_added() {
    webengage.track('kitchen_item_added');
  }
  registered() {
    webengage.track('registered');
  }
}
